var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sfs-form-modal',{attrs:{"id":_vm.modalId,"size":"lg","title":`Edit ${_vm.$store.getters.translate('client', 'Client')}`},on:{"on-hide":_vm.resetFormData}},[_c('clients-form',_vm._b({key:_vm.formKey,on:{"on-submit":_vm.updateClient,"on-save":_vm.onSave,"on-cancel":_vm.closeModal}},'clients-form',_vm.value,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }